import {apiTs} from '../../../services/api';

export const DepartmentsHTTP = {
  get: (params = {}) => apiTs.get('/departments', {params}),
  create: (payload = {}) => apiTs.post('/departments', payload),
  update: (id = '', payload = {}) => apiTs.put(`/departments/${id}`, payload),
};
